import { useIntl } from "react-intl";
import { useState, useCallback } from "react";

//Components
import { Checkbox, Button, TableView, Toolbar, ToggleSwitch } from "@gpstrackit/react-controls";
import { Grid, Collapse } from "@mui/material";


const TableAlertTypes = (props) => {
    const {
        alertTypes,
        indent = 0,
        loading = false,
        setChanges,
        id,
        selected,
        setSelected,
        parents,
    } = props;

    const { messages } = useIntl();

    const [expanded, setExpanded] = useState([]);
    const [currentSearch, setCurrentSearch] = useState("");
    const [expandAll, setExpandedAll] = useState(false);

    const expand = useCallback((nodeId) => {
        let newExpanded = [...expanded];
        if (expanded.includes(nodeId)) {
            newExpanded = expanded.filter(e => e != nodeId);
        } else newExpanded.push(nodeId);
        setExpanded(newExpanded);
    });

    const handlerExpandAll = (value) => {
        if (value) setExpanded([12])
        else setExpanded([])
        setExpandedAll(value)
    }

    return (
        <TableView
            name="features-list-level"
            onSearch={(search) => setCurrentSearch(search)}
            data={currentSearch ? alertTypes : id ? alertTypes?.filter((item) => item?.parentId === id) : alertTypes?.filter((item) => !item?.parentId) || []}
            viewType="list"
            messages={messages}
            topSpaceSize={!id ? 350 : 415}
            inputSearch={!id || false}
            itemSelector={false}
            renderRow={(feature) => {
                let validateModule = alertTypes?.some((item) => item?.parentId === feature?.id)
                return (
                    <div style={{ minWidth: 650 }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            className="row-features"
                        >
                            <Grid item xs={6}>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    style={{ marginLeft: indent }}
                                    wrap="nowrap"
                                >
                                    <Grid item style={{ marginTop: 10 }}>
                                        {
                                            (!id && validateModule) && !currentSearch ?
                                                <>
                                                    <Button
                                                        type="icon"
                                                        icon={expanded.includes(feature.id) ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}
                                                        placement="bottom"
                                                        className="btn-xs"
                                                        fontSize="inherit"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            let currentId = feature?.tempId || feature.id
                                                            expand(currentId)
                                                        }}
                                                    />
                                                </> :
                                                <div style={{ width: 24, height: 24 }}></div>
                                        }
                                    </Grid>
                                    <Grid item xs>
                                        <div style={{ height: 30 }}>
                                            <Checkbox
                                                id={feature?.name}
                                                label={feature?.name}
                                                value={selected?.includes(feature.id)}
                                                onChange={(checked) => {
                                                    let current = selected
                                                    if (!checked) {

                                                        //when the parent is unchecked
                                                        let parentIdValidation = parents?.length ? parents?.includes(feature.id) : false
                                                        if (parentIdValidation) {
                                                            let childs = alertTypes.filter((item) => item.parentId).map((item) => (item.id))
                                                            current = current.filter((item) => !childs.includes(item));
                                                        }

                                                        let index = current.findIndex((item) => item === feature.id);
                                                        if (index > -1) current.splice(index, 1);
                                                        setSelected([...current])
                                                    } else {
                                                        if (feature?.parentId && !selected.includes(feature?.parentId)) {
                                                            current.push(feature?.parentId)
                                                        }
                                                        current.push(feature.id)
                                                        setSelected([...current])
                                                    }
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        {
                            !currentSearch &&
                            <Collapse in={expanded.includes(feature.id) || expanded.includes(feature.tempId)} timeout="auto" unmountOnExit>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    style={{ padding: '0px 0px 0px 0px' }}
                                >
                                    <TableAlertTypes
                                        id={feature.id}
                                        indent={indent + 30}
                                        loading={loading}
                                        alertTypes={alertTypes}
                                        setChanges={setChanges}
                                        selected={selected}
                                        setSelected={setSelected}
                                    />
                                </Grid>
                            </Collapse>
                        }
                    </div>
                )
            }}
            pagination={false}
            toolbarContainerClassName='table-alert-types-toolbar'
        >
            {
                !id && (
                    <Toolbar>
                        <div style={{ marginTop: 5, marginLeft: 20 }}>
                            <ToggleSwitch
                                id="toogle-expand-all"
                                large
                                blueToggle
                                optionLabels={[messages['common_contract'], messages['common_expand']]}
                                checked={expandAll}
                                onChange={handlerExpandAll}
                            />
                        </div>
                    </Toolbar>
                )
            }
        </TableView>
    )
}

export default TableAlertTypes